import { forwardRef } from "react"
import API from "web/hooks/data/api"
import { SelectX } from "web/components"

import { useSearch } from "web/hooks/data"

import { isObjectWithProperty, wrapArray } from "web/services/helpers"

import ControlContainer from "./ControlContainer"
import { useDuplicateCompanyModal } from "web/hooks/modals"

const CompanyLookup = forwardRef((props, ref) => {
  const {
    name,
    value,
    kind,
    error,
    touched,
    multiple_values,
    onChange,
    onFocus,
    autoFocus,
    disabled = false,
    canShowAddXOption = true,
  } = props

  const search = useSearch("company")
  const duplicateCompanyModal = useDuplicateCompanyModal({
    createNewCompany: handleQuickAdd,
    selectExistingCompany: handleSelectXChange,
    multipleValues: multiple_values,
    selectedValues: wrapArray(value),
  })

  async function decodeValue(rawValue) {
    return { value: rawValue.value, label: rawValue.label, kind }
  }

  async function handleSelectXChange(value) {
    if (value === null) {
      onChange(null)
    } else if (multiple_values) {
      const decodedValue = []

      for (const valueEl of value) {
        decodedValue.push(await decodeValue(valueEl))
      }

      onChange(decodedValue)
    } else {
      onChange(await decodeValue(value))
    }
  }

  async function handleQuickAdd(nameOfNew) {
    const newObj = await API.post("/companies", { name: nameOfNew })

    if (isObjectWithProperty(newObj, "id")) {
      const newValue = { value: newObj.id, label: nameOfNew, kind }

      if (multiple_values) {
        onChange([...(value || []), newValue])
      } else {
        onChange(newValue)
      }
    }
  }

  async function onQuickAdd(nameOfNew) {
    const searchResults = await search(nameOfNew, {
      limit: 5,
      with_threshold: true,
    })

    if (searchResults.length > 0) {
      await duplicateCompanyModal({
        name: nameOfNew,
        searchResults: searchResults,
      })
    } else {
      await handleQuickAdd(nameOfNew)
    }
  }

  return (
    <ControlContainer {...props} errorCondition={error && touched}>
      <SelectX
        ref={ref}
        name={name}
        value={value}
        onChange={handleSelectXChange}
        onFocus={onFocus}
        onAdd={canShowAddXOption ? onQuickAdd : undefined}
        validValues={search}
        options={{
          multipleValues: multiple_values || false,
          clearOnFocus: true,
          inputClassName: "form-control lookup",
          autoFocus,
          placeholder: "Search companies...",
        }}
        disabled={disabled}
      />
    </ControlContainer>
  )
})

export default CompanyLookup
